<template>
  <div class="card-box tilebox-three">
    <div class="table-container">
      <div class="table-cell" style="width: 30%; padding-right: 20px">
        <el-progress :width="100" type="circle" :status="getProgressPercent(true) === 100 ? 'success' : ''" :percentage="getProgressPercent(true)"></el-progress>
      </div>
      <div class="table-cell" style="width: 70%">
        <h6 :style="{color: objective.call_type.planning_color}" class="text-uppercase m-b-10">{{ objective.call_type.name }} : {{ objective.name }}</h6>

        <h2 style="display: inline;">{{ getProgressLabel() }}</h2>

        <span v-if="getObjectiveRealTimeRatio() > 0" class="label label-success">+{{ getObjectiveRealTimeRatio() }} %</span>
        <span v-else class="label label-danger">{{ getObjectiveRealTimeRatio() }} % </span>

        <div class="m-t-10">
          <div v-for="level in objective.month_levels">
            {{ objective.month_tag_count ? objective.month_tag_count.computed.count.sum : 0 }} / {{ Math.round(level.threshold) }} :
              <strong>{{ level.amount }} €</strong>
            <span v-if="objective.month_tag_count === null" class="label label-warning">0 %</span>
            <span v-else-if="objective.month_tag_count.computed.count.sum >= level.threshold" class="label label-success">Atteint !</span>
            <span v-else class="label label-warning">{{ 100 - Math.round(objective.month_tag_count.computed.count.sum / level.threshold * 100) }} % restant</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'objective-widget',
    props: ['objective'],
    methods: {
      getProgressLabel () {
        let actual = this.objective.month_tag_count ? this.objective.month_tag_count.computed.count.sum : 0
        let targetIndex = this.objective.levels.findIndex(item => item.threshold === 100)
        let target = this.objective.month_levels[targetIndex].threshold
        return actual + ' / ' + (new Intl.NumberFormat().format(target))
      },
      getProgressPercent (maximum) {
        let actual = this.objective.month_tag_count ? this.objective.month_tag_count.computed.count.sum : 0
        let targetIndex = this.objective.levels.findIndex(item => item.threshold === 100)
        let target = this.objective.month_levels[targetIndex].threshold
        let percent = Math.round(actual / target * 100)

        if (maximum) {
          percent = percent > 100 ? 100 : percent
        }

        return percent
      },
      getObjectiveRealTimeRatio () {
        let actual = this.objective.month_tag_count ? this.objective.month_tag_count.computed.count.sum : 0
        let target = this.objective.hourly_ratio * this.objective.month_call_type_duration / 60

        return Math.round(actual / target * 100) - 100
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ObjectiveWidget.vue?0ff15925